export default "__VITE_ASSET__D7JwX83k__"